import BigNumber from 'bignumber.js';

// Converts an amount from decimal to token format
export const convertDecimalsToAmount = (input: string | number | BigNumber, decimals: number) => {
  if (
    input === undefined || input === null || input === '' || isNaN(Number(input)) ||
    decimals === undefined || decimals === null || !Number.isFinite(decimals)
  ) {
    return '0';
  }
  const powerOfTen = new BigNumber(10).pow(decimals);
  const value = new BigNumber(input);
  if (!value.isFinite()) return '0';
  return value.times(powerOfTen).toFixed(0, BigNumber.ROUND_FLOOR);
};

// Converts an amount from token to decimal format
export const convertTokensToDecimals = (
  amount: string | number | bigint | BigNumber,
  decimals: number
) => {
  if (
    amount === undefined || amount === null || amount === '' || isNaN(Number(amount)) ||
    decimals === undefined || decimals === null || !Number.isFinite(decimals)
  ) {
    return '0';
  }
  const powerOfTen = new BigNumber(10).pow(decimals);
  const value = new BigNumber(amount.toString());
  if (!value.isFinite()) return '0';
  return value.div(powerOfTen).toFixed();
};
